import { createStandaloneToast } from '@chakra-ui/react'

export function base64ToBlobURI(base64: string, mimeType: string) {
  // Decode Base64 string to binary data
  const byteCharacters = atob(getBase64Data(base64))
  const byteNumbers = new Array(byteCharacters.length)
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i)
  }
  const byteArray = new Uint8Array(byteNumbers)

  // Create a Blob from binary data
  const blob = new Blob([byteArray], { type: mimeType })

  // Generate a Blob URI
  return URL.createObjectURL(blob)
}

export function convertToBase64(
  file: File,
  callback: (data: { data: string; mimeType: string }) => void
) {

  try {

    const reader = new FileReader()
    
    reader.onload = function (e) {
      const base64 = e.target.result as string
      const start = base64.indexOf("/") + 1
      const end = base64.indexOf(";")
      
      const mimeType = base64.slice(start, end)
      callback({ data: base64, mimeType })
    }
    
    reader.onerror = function (error) {
      console.error("Error: ", error)
    } 
    reader.readAsDataURL(file)
  } catch (err) {
    window.alert("Please try again")
    callback({data: "", mimeType: ""})
  }
}

const getBase64Data = (base64URI: string) => base64URI.split(",").pop()
